import React from 'react';
import styled from '../../styled';
import { COLORS } from '../../themes/color';

const Badge = styled('span')`
  display: inline-block;
  background-color: ${COLORS.PRIMARY};
  color: white;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 4px;
  width: fit-content;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const NewBadge = ({
  children = 'New'
}: {
  children?: React.ReactNode;
}) => {
  return <Badge>{children}</Badge>;
};
